
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/eSwarna-digital-gold/coupons",
      function () {
        return require("private-next-pages/help/eSwarna-digital-gold/coupons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/eSwarna-digital-gold/coupons"])
      });
    }
  